import { Journal, JournalAdapter, JournalQueryResult, ReduxAction } from '../common';

export enum JournalActionTypes {
  InitiantedJournalStateReducers = '[JournalStateStore] Initianted Journal State Reducers',
  SetJournalStaticSettings = '[JournalStateStore] Set Journal Static Settings',
  SetJournalCode = '[JournalStateBase] Set Journal Code',
  RefreshQueryResult = '[JournalStateStore] Refresh Query Result',
  SetQueryResult = '[JournalStateStore] Set Query Result',
  SetSearchText = '[JournalStateStore] Set Search Text',
  // SetJournalInfo = '[JournalStateStore] Set Journal Info',
}

export interface InitiantedJournalStateReducersAction extends ReduxAction {
  readonly type: JournalActionTypes.InitiantedJournalStateReducers;
}

export interface SetJournalCodeAction extends ReduxAction {
  readonly type: JournalActionTypes.SetJournalCode;
  readonly payload: string | null;
}

export interface SetJournalStaticSettingsAction extends ReduxAction {
  readonly type: JournalActionTypes.SetJournalStaticSettings;
  readonly payload: Journal;
}

export interface RefreshQueryResultAction extends ReduxAction {
  readonly type: JournalActionTypes.RefreshQueryResult;
}

export interface SetSearchTextAction extends ReduxAction {
  readonly type: JournalActionTypes.SetSearchText;
  readonly payload: string;
}
export interface SetQueryResultAction extends ReduxAction {
  readonly type: JournalActionTypes.SetQueryResult;
  readonly payload: JournalQueryResult;
}

// export interface SetJournalInfoAction extends ReduxAction {
//   readonly type: JournalActionTypes.SetJournalInfo;
//   readonly payload: Journal;
// }

export type JournalActions =
  | InitiantedJournalStateReducersAction
  | SetJournalCodeAction
  | SetJournalStaticSettingsAction
  | RefreshQueryResultAction
  | SetQueryResultAction
  | SetSearchTextAction;
// | SetJournalInfoAction;
